
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'underscore';

import { acBilet } from '../actions/acBilet';
import { acRundaSelectata } from '../actions/acRundaSelectata';
import { acAxiosRequest } from '../actions/acAxiosRequest'
class ConBile extends React.Component {

    // constructor() {
    //     super();
    //     this.state = { active: false };

    // }

    shouldComponentUpdate(nextProps, nextState) {
        if ((nextProps.rundeActive) && (this.props.type === 'multy')) {
            var rundaVal = nextProps.rundaVal.round_unique;
            var result = nextProps.rundeActive.filter(function (obj) {
                return obj === rundaVal;
            });
            if (result.length !== 0) {
                return true;
            } else {
                return false;
            }
        }
        else {
            return true
        }
    }


    bile() {
        if (this.props.activeLot) {
            var arr = []
            for (var i = 0; i < this.props.activeLot.nr_balls; i++) {
                var i2 = i + 1
                arr.push(<div key={i} className={this.bileClass(i2)} onClick={this.activeBila.bind(this, i2)}><span>{i2}</span></div>)
            }
            return arr;
        }
    }
    bileClass(val) {
        if (this.props.bilete !== null) {
            var findTicket = _.findWhere(this.props.bilete, { position: this.props.biletTab });
            if (this.props.type === 'multy') {
                var roundUnique = this.props.rundaVal.round_unique
            } else {
                // console.log(')))', findTicket.roundUnique);
                // if (findTicket) {
                //     roundUnique = findTicket.roundUnique
                // } else {
                // }
                roundUnique = this.props.rundaSelectata.round_unique
            }
            if (findTicket && (findTicket.roundUnique === roundUnique)) {
                var findNr = _.contains(findTicket.numereArr, val);
                if ((findNr === true) && (findTicket.numeLot === this.props.activeLot.name_lot)) {
                    return 'bila-active'
                }
            } else {

            }
        }
        return 'bila';
    }

    activeBila(val) {
        if (this.props.type === 'multy') {
            var rundaVal = this.props.rundaVal
        } else {
            rundaVal = this.props.rundaSelectata
        }
        var roundUnique = rundaVal.round_unique;
        var position = this.props.biletTab;
        var valBiletNou = {
            idRunda: rundaVal.id,
            roundUnique: roundUnique,
            numereArr: [val],
            timeStart: rundaVal.timeStart,
            numeLot: rundaVal.selectedLot,
            gameType: this.props.activeLot.game_type,
            odds: this.props.activeLot.odds,
            miza: 0,
            currency: this.props.defaultVal.currency,
            checked: [1],
            cotaTot: 0,
            castigEv: 0,
            sum: [],
            coteFixe: [],
            position: this.props.biletTab,
            valid: true,
            pariat: false,
            mesaj: '',
            future: 0,
            futureSuccess: 0,
            futureError: 0,
            futureErrorRounds: [],
            futureMessage: [this.props.multiLang.biletePariate.txt, this.props.multiLang.bileteEsuate.txt],
            nrFavorite: null
        }
        var nrFav = {
            ruta: this.props.appProps.ruta,
            reducer: 'NR_FAVORITE',
            request: 'get_user_favorites',
            value: 'lottery_name=' + this.props.activeLot.name_lot.replace(/ /g, "_"),
            error: '5100',
            reducer2: 'BILET_SAVE_FAV_FROM_AXIOS',
            extra: this.props.biletTab,
            newParam: this.props.sessionParam
        }

        if (this.props.bilete !== null) {
            var filterPosition = this.props.bilete.filter(function (obj) {
                return obj.position === position;
            });
            if (filterPosition.length === 0) {
                this.props.acBilet(['biletNou', valBiletNou])
                if (this.props.appProps.colMid !== "Mid1ConNr") { this.props.acAxiosRequest(nrFav) }
            }
            if (filterPosition.length !== 0) {
                if (filterPosition[0].position === this.props.biletTab) {
                    if ((filterPosition[0].roundUnique === rundaVal.round_unique) && (filterPosition[0].numeLot === this.props.activeLot.name_lot)) {
                        var values = {
                            position: filterPosition[0].position,
                            number: val,
                            biletNumbers: filterPosition[0].numereArr,
                            odds: this.props.activeLot.odds
                        }
                        this.props.acBilet(['biletNumere', values])
                    } else {
                        this.props.acBilet(['biletNouSamepoz', valBiletNou])
                    }
                }
            }
        }
        else {
            this.props.acBilet(['biletNou', valBiletNou])
            if (this.props.appProps.colMid !== "Mid1ConNr") { this.props.acAxiosRequest(nrFav) }
        }
    }
    render() {
        // console.log('ConBile', this.props);
        return (
            <div className="con-bile">
                {this.bile()}
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        activeLot: state.activeLot,
        bilete: state.bilete,
        defaultVal: state.defaultVal,
        biletTab: state.biletTab,
        rundeActive: state.rundeActive,
        rundaSelectata: state.rundaSelectata,
        appProps: state.appProps,
        multiLang: state.multiLang,
        sessionParam: state.sessionParam
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acBilet: acBilet,
        acRundaSelectata: acRundaSelectata,
        acAxiosRequest: acAxiosRequest
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ConBile);
